import { EPillarType } from '../dashboard';

export type AnalyticsBaselineAssessmentParticipants = {
  givenStudentCount: number;
  participatedGivenStudents: number;
  participatedGlobalStudents: number;
  participatedSchoolStudents: number;
  totalSchoolStudents: number;
  totalStudents: number;
};

export type AnalyticsBaselineAssessmentResultPillar = {
  blurbs: {
    [key: string]: string;
  };
  modules: {
    [x: string]: number;
  };
  overall: number;
};

export type AnalyticsBaselineAssessmentResultItem = {
  [EPillarType.ACTIVE_CITIZENSHIP]: AnalyticsBaselineAssessmentResultPillar;
  [EPillarType.CAREER_READINESS]: AnalyticsBaselineAssessmentResultPillar;
  [EPillarType.COMMUNICATION]: AnalyticsBaselineAssessmentResultPillar;
  [EPillarType.LEARNING]: AnalyticsBaselineAssessmentResultPillar;
  [EPillarType.PERSONAL_DEVELOPMENT]: AnalyticsBaselineAssessmentResultPillar;
};

export type AnalyticsBaselineAssessmentResults = {
  globalResults: AnalyticsBaselineAssessmentResultItem;
  schoolResults: AnalyticsBaselineAssessmentResultItem;
  studentResults: AnalyticsBaselineAssessmentResultItem;
};

export type AnalyticsGroupSurveyResponseItem = {
  percentage: number;
  response_count: number;
};

export enum ESurveyType {
  AGREEMENT = 'AGREEMENT',
  FREQUENCY = 'FREQUENCY',
}

export enum ESurveyResponseType {
  AGREE = 'AGREE',
  DISAGREE = 'DISAGREE',
  NEUTRAL = 'NEUTRAL',
  STRONGLY_AGREE = 'STRONGLY_AGREE',
  STRONGLY_DISAGREE = 'STRONGLY_DISAGREE',
  ALWAYS = 'ALWAYS',
  NEVER = 'NEVER',
  OFTEN = 'OFTEN',
  RARELY = 'RARELY',
  SOMETIMES = 'SOMETIMES',
}

export type AnalyticsGroupSurveyResponse = {
  [ESurveyResponseType.AGREE]?: AnalyticsGroupSurveyResponseItem;
  [ESurveyResponseType.DISAGREE]?: AnalyticsGroupSurveyResponseItem;
  [ESurveyResponseType.NEUTRAL]?: AnalyticsGroupSurveyResponseItem;
  [ESurveyResponseType.STRONGLY_AGREE]?: AnalyticsGroupSurveyResponseItem;
  [ESurveyResponseType.STRONGLY_DISAGREE]?: AnalyticsGroupSurveyResponseItem;
  [ESurveyResponseType.ALWAYS]?: AnalyticsGroupSurveyResponseItem;
  [ESurveyResponseType.NEVER]?: AnalyticsGroupSurveyResponseItem;
  [ESurveyResponseType.OFTEN]?: AnalyticsGroupSurveyResponseItem;
  [ESurveyResponseType.RARELY]?: AnalyticsGroupSurveyResponseItem;
  [ESurveyResponseType.SOMETIMES]?: AnalyticsGroupSurveyResponseItem;
};

export type AnalyticsPillarStatsType = {
  student_count: number;
  avg_module_completion_percentage: number;
  overall_average_score: number;
};
export type AnalyticsPillarSkillType = {
  skill_id: string;
  name: string;
  skill_score: number;
};

export type AnalyticsModuleAttemptType = {
  attempt: number;
  activityGrade: number;
  activityTimeSpent: string;
  assessmentGrade: number;
  assessmentTimeSpent: string;
};

export type AnalyticsModuleType = {
  moduleId: string;
  moduleName: string;
  moduleInfoName?: string;
  moduleInfoId?: string;
  result: AnalyticsModuleAttemptType[];
};
